import { useState } from "react";
import { matchPath, useHistory, useLocation } from "react-router-dom";
import { Box, Divider, H5, Loading, Notification } from "orcs-design-system";

import PATHS, { url } from "src/consts/urlPaths";
import InboxList from "src/inbox/InboxList";
import { arrivedFromInterstitial } from "src/inbox/inboxTransition";
import type { InboxCategory } from "src/inbox/kinds";
import { INBOX_PAGE_SIZE, useInboxItems } from "src/inbox/useInboxItems";

/** Highlight the open item. `/inbox` with no id shows the landing, so none. */
export const selectedInboxKey = (pathname: string): string | null =>
  matchPath<{ itemId?: string }>(pathname, {
    path: PATHS.WORKFORCE_INBOX,
  })?.params.itemId ?? null;

const InboxContent = () => {
  const history = useHistory();
  const { pathname, state } = useLocation();
  const [category, setCategory] = useState<InboxCategory>("EVERYTHING");
  const { items, counts, loading, error, hasMore, loadingMore, loadMore } =
    useInboxItems(true, { category, pageSize: INBOX_PAGE_SIZE });
  const selectedKey = selectedInboxKey(pathname);
  const arrivedKey = arrivedFromInterstitial(state) ? selectedKey : null;
  const showLoading = loading && items.length === 0;
  const showError = !showLoading && Boolean(error) && items.length === 0;

  return (
    <Box>
      <H5 fontWeight="bold">Inbox</H5>
      <Box my="r">
        <Divider light />
      </Box>
      {showLoading ? <Loading /> : null}
      {showError ? (
        <Notification variant="error" closable={false}>
          The inbox could not be loaded.
        </Notification>
      ) : null}
      {!showLoading && !showError ? (
        <InboxList
          items={items}
          selectedKey={selectedKey}
          arrivedKey={arrivedKey}
          category={category}
          counts={counts}
          hasMore={hasMore}
          loadingMore={loadingMore}
          onCategoryChange={setCategory}
          onSelect={(key) => {
            history.push(url(PATHS.WORKFORCE_INBOX, { itemId: key }));
          }}
          onLoadMore={loadMore}
        />
      ) : null}
    </Box>
  );
};

export default InboxContent;
